import RecordItem from './records-item';

export default RecordItem;
